import { render, staticRenderFns } from "./TicketEmail.vue?vue&type=template&id=71e03b30&scoped=true"
import script from "./TicketEmail.vue?vue&type=script&lang=js"
export * from "./TicketEmail.vue?vue&type=script&lang=js"
import style0 from "./TicketEmail.vue?vue&type=style&index=0&id=71e03b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e03b30",
  null
  
)

export default component.exports